import React from 'react';
import {
  Modal as ReactstrapModal,
  ModalBody,
  ModalFooter,
  ModalTitle,
} from 'react-bootstrap';
import ModalHeader from 'react-bootstrap/esm/ModalHeader';

interface IModal {
  body?: React.ReactNode;
  title?: React.ReactNode;
  show?: boolean;
  toggle?: () => void;
  footer?: React.ReactNode;
}

const Modal = (props: IModal) => {
  const { show, toggle } = props;
  return (
    <ReactstrapModal
      show={show}
      onHide={() => {
        if (toggle) {
          toggle();
        }
      }}
    >
      {(Boolean(toggle) || props.title) && (
        <ModalHeader closeButton={Boolean(toggle)}>
          {props.title && <ModalTitle>{props.title}</ModalTitle>}
        </ModalHeader>
      )}
      {props.body && <ModalBody>{props.body}</ModalBody>}
      {props.footer && <ModalFooter>{props.footer}</ModalFooter>}
    </ReactstrapModal>
  );
};

export default Modal;
